import React from 'react';
// style
import styled from 'styled-components';
// components
import { components } from 'components/CustomSelect';

const DropdownOption = ({ className, children, ...props }) => {
  const { data } = props;
  const { subLabel } = data;
  return (
    <components.Option {...props} className={className}>
      {children} <span className="sub-text">{subLabel}</span>
    </components.Option>
  );
};

export default styled(DropdownOption)`
  position: relative;

  .sub-text {
    font-size: 1.4rem;
    color: var(--grey700);
  }
`;
